// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import {
  getSupabasePublishableKey,
  getSupabaseUrl,
  hasPublicSupabaseConfig,
} from '@/lib/publicSupabaseConfig';

export const isSupabaseClientConfigured = hasPublicSupabaseConfig();

// Keep an unconfigured staging/preview build mountable enough to show the
// configuration screen. The .invalid host is deliberately unreachable and
// cannot be mistaken for a real Supabase project.
const SUPABASE_URL = getSupabaseUrl() || 'https://unconfigured.supabase.invalid';
const SUPABASE_PUBLISHABLE_KEY = getSupabasePublishableKey() || 'unconfigured-anon-key';

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});
